import React from 'react';
import classes from './style.module.css'
import { Button } from 'react-bootstrap';
import { export_table_to_csv } from '../../util/export/csv-exporter'
import { MODE_HOT_JOCKEY, MODE_MATCHES, HOME, AWAY } from "../../constants/Constants"

const ExportData = props => {

    const exportButtonClickedHandler = () => {
        let filename = props.selectionDate
        let tab = document.querySelector("#fileName")
        if (tab) {
            const tab = document.querySelector("#fileName").innerHTML.replace(" ", "_");;
            filename = filename + "_" + tab + ".csv"
            const html = document.querySelector("#runnerDetails");
            export_table_to_csv(html, filename, props.selectionDate)
        } else {
            window.location.href = "https://agrapi.makebettinggreat.com/v1/race/detail/report/" + filename
        }
    }

    let tab = document.querySelector("#fileName")

    return (
        <div className={classes.ExportData}>
            <Button size="sm" variant="dark" onClick={exportButtonClickedHandler}>{props.label}</Button>
        </div>
    );
}

export default ExportData;